
 const baseURL = "https://crewgenix.com"; // production
  // const baseURL = "http://localhost:8000"; // Development


export default baseURL;